<div class="row no-data m-0">
  <div class="col-md-12">
    <img class="empty-state" src="/assets/img/lock.png" />
    <div class="col-sm-12">
      <h6> {{"not-full-market-hint"|translate}} </h6>
    </div>
  </div>
</div>
